import { useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import CustomButton from '../reusable/CustomButton';
import Footer from '../footer/Footer';
import { Navigate } from 'react-router-dom';
import Loader from '../reusable/Loader';
import EOAALogo from '../assets/eoaa-logo-horizontal.svg';
import HeroImage from '../assets/login-hero-image.svg';

import './LoginPage.css';

function Login() {

  const { isAuthenticated, isLoading, loginWithRedirect } = useAuth0();

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const invitation = searchParams.get('invitation');
    const organization = searchParams.get('organization');
    const organization_name = searchParams.get('organization_name');

    if (!isLoading && !isAuthenticated && invitation && organization && organization_name) {
      loginWithRedirect({authorizationParams: { invitation: invitation || '', organization: organization || '', organization_name: organization_name}});
    }
  }, [isAuthenticated, isLoading]);

  if (isAuthenticated) return <Navigate to="/overview" />;

  const handleSignIn = () => {
    loginWithRedirect();
  };

  return (
    <div className="login-container">
      { isLoading ? <Loader fullScreen={true} /> : null}
      <div className="content-container">
        <div className="hero-text">
          <img src={EOAALogo} alt="XQ educational outcomes audit and analysis"></img>
          <h1 className="heading">Sign in to continue your journey</h1>
          <p className="description">Sign in using your district or education organization's email account. By signing in, you agree to XQ's &nbsp;
            <a href="https://xqsuperschool.org/privacy-policy" target="_blank" rel="noreferrer" className="link">privacy policy</a>
            &nbsp; and &nbsp;
            <a href="https://xqsuperschool.org/terms" target="_blank" rel="noreferrer" className="link">terms of service</a>.
          </p>
          <CustomButton size="medium" variant="secondary" buttonText="Sign in" buttonAction={handleSignIn} />
        </div>
        <img src={HeroImage} alt="a group of students" className="hero-image"></img>
      </div>
      <Footer classNameProp="login"/>
    </div>
  );
}

export default Login;